import styled from 'styled-components';

export const PortalPage = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #0F1828;
  color: #F5F1E8;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background-image:
    radial-gradient(circle at 20% 20%, rgba(184, 147, 90, .08) 0%, transparent 40%),
    radial-gradient(circle at 80% 80%, rgba(184, 147, 90, .08) 0%, transparent 45%);
`;

export const Card = styled.form`
  width: 100%;
  max-width: 440px;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(184, 147, 90, .22);
  border-radius: 14px;
  padding: 44px 38px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .4);
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0; left: 50%;
    transform: translateX(-50%);
    width: 60px; height: 2px;
    background: #B8935A;
  }
`;

export const LogoBox = styled.div`
  margin-bottom: 4px;
  img { height: 50px; width: auto; display: block; }
`;

export const Subtitle = styled.div`
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: 18px;
  color: rgba(245, 241, 232, .8);
  letter-spacing: 1px;
  font-style: italic;
  margin-bottom: 8px;
`;

export const Field = styled.label`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 10px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  color: rgba(245, 241, 232, .55);
  font-weight: 600;
  input {
    background: rgba(15, 24, 40, .6);
    border: 1px solid rgba(184, 147, 90, .25);
    color: #F5F1E8;
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 14px;
    font-family: inherit;
    letter-spacing: 0.2px;
    text-transform: none;
    font-weight: 400;
    outline: none;
    transition: border-color .15s;
    &:focus { border-color: #B8935A; }
    &:disabled { opacity: .6; cursor: not-allowed; }
  }
`;

export const Msg = styled.div`
  width: 100%;
  font-size: 12px;
  color: ${p => p.$ok ? '#5BB089' : '#E18079'};
  text-align: center;
  letter-spacing: 0.2px;
  line-height: 1.4;
`;

export const SubmitBtn = styled.button`
  width: 100%;
  margin-top: 10px;
  background: #B8935A;
  color: #fff;
  border: 1px solid #B8935A;
  padding: 13px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  cursor: pointer;
  font-family: inherit;
  transition: transform .15s, box-shadow .15s;
  &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(184, 147, 90, .3); }
  &:disabled { opacity: .6; cursor: not-allowed; transform: none; box-shadow: none; }
`;

export const LinkBtn = styled.button`
  background: transparent;
  border: none;
  color: rgba(245, 241, 232, .55);
  font-size: 11px;
  letter-spacing: 0.5px;
  cursor: pointer;
  padding: 4px 8px;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-family: inherit;
  &:hover { color: #D4A56A; }
`;

export const Footer = styled.div`
  margin-top: 6px;
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgba(245, 241, 232, .35);
  text-align: center;
`;
